import type { BusinessStructure } from '@paid-ui/enums/business';

import { z } from 'zod';

import { BusinessType } from '@paid-ui/enums/business';
import { optionalABNSchema } from '@paid-ui/schemas/zod/abn';
import { acnSchema } from '@paid-ui/schemas/zod/acn';
import { businessStructureSchema } from '@paid-ui/schemas/zod/business';
import { businessNameSchema } from '@paid-ui/schemas/zod/business-name';
import { emailSchema } from '@paid-ui/schemas/zod/email';
import { oneTimeCodeSchema } from '@paid-ui/schemas/zod/one-time-code';
import { passwordSchema } from '@paid-ui/schemas/zod/password';
import { phoneNumberSchema } from '@paid-ui/schemas/zod/phone';
import { userNameSchema } from '@paid-ui/schemas/zod/user-name';

import { OwnerType, RoleInBusiness, RoleInCompany, TrustType } from './models/enums';

export const businessTypeSchema = z
  .nativeEnum(BusinessType)
  .or(z.literal(''))
  .refine((v) => v !== '', {
    message: 'Required field',
  });

export const signUpFormSchema = z.object({
  type: businessTypeSchema,
  email: emailSchema,
  agreedOnTerms: z.boolean(),
  isEmployee: z.boolean().optional(),
  ownerType: z.nativeEnum(OwnerType),
  structure: businessStructureSchema,
  abn: optionalABNSchema,
  businessName: businessNameSchema,
  roleInBusiness: z
    .nativeEnum(RoleInBusiness)
    .or(z.literal(''))
    .refine((v) => v !== '', {
      message: 'Required field',
    }),
  companyName: businessNameSchema,
  acn: acnSchema,
  roleInCompany: z
    .nativeEnum(RoleInCompany)
    .or(z.literal(''))
    .refine((v) => v !== '', {
      message: 'Required field',
    }),
  trustName: businessNameSchema,
  trustType: z
    .nativeEnum(TrustType)
    .or(z.literal(''))
    .refine((v) => v !== '', {
      message: 'Required field',
    }),
  firstName: userNameSchema,
  lastName: userNameSchema,
  mobile: phoneNumberSchema,
  password: passwordSchema,
  oneTimeCode: oneTimeCodeSchema,
  inviterName: z.string().min(1, 'Required field'),
  inviteeEmail: emailSchema,
});

export interface SignUpFormValues {
  type: BusinessType | '';
  email: string;
  agreedOnTerms: boolean;
  isEmployee?: boolean;
  ownerType: OwnerType;
  structure: BusinessStructure | '';
  abn: string;
  businessName: string;
  roleInBusiness: RoleInBusiness | '';
  companyName: string;
  acn: string;
  roleInCompany: RoleInCompany | '';
  trustName: string;
  trustType: TrustType | '';
  firstName: string;
  lastName: string;
  mobile: string;
  password: string;
  oneTimeCode: string;
  inviterName: string;
  inviteeEmail: string;
}
